module.exports = __webpack_public_path__ + "static/media/CTLA_8-286w.f6005f98.webp";